import { render, staticRenderFns } from "./TableDataSelect.vue?vue&type=template&id=5122221f&scoped=true"
import script from "./TableDataSelect.vue?vue&type=script&lang=js"
export * from "./TableDataSelect.vue?vue&type=script&lang=js"
import style0 from "./TableDataSelect.vue?vue&type=style&index=0&id=5122221f&prod&lang=scss"
import style1 from "./TableDataSelect.vue?vue&type=style&index=1&id=5122221f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5122221f",
  null
  
)

export default component.exports